import api from './api';

const endpoint = '/api/v1/ecommerce/promos';

export default {

    async get() {
        return await api.get(endpoint);
    },

    async add(promoCode) {
        return await api.post(endpoint, {
            promoCode: promoCode,
        });
    },

    async delete(promoCode) {
        return await api.delete(`${endpoint}/${promoCode}`);
    },

    mapPromoCodesToPromos(promoObjects) {
        return promoObjects.reduce( function(promoMapped, promo) {
            promoMapped[promo.code] = promo;
            return promoMapped;
        }, new Map());
    },

    formatPromoCode(promoObject) {
        if (!promoObject) {
            return '';
        }
        
        if (promoObject.actualCode) {
            return promoObject.actualCode;
        }

        return promoObject.code;
    },

    freeAtCheckoutPromoCodeExists(promoObjects) {
        let freeAtCheckoutPromo = promoObjects.find((promo) => {
           return promo.type == 'freeAtCheckout';
        });

        console.log('free at checkout code: ', freeAtCheckoutPromo);

        return freeAtCheckoutPromo != null;
    }
}
